var paymentStatus = {
  AUTHORISED: 'AUTHORISED',
  CREATED: 'CREATED',
  DECLINED: 'DECLINED'
};
export { paymentStatus as default };